import axios from "axios";
import { params, header, selectScopedAnomalyRuleAPI, anomalyRuleAPI, } from "../_api";

import {
  FETCH_SELECT_SCOPED_ANOMALY_RULE_REQUEST,
  FETCH_SELECT_SCOPED_ANOMALY_RULE_SUCCESS,
  FETCH_SELECT_SCOPED_ANOMALY_RULE_FAILURE,
  FETCH_SPECIFIC_ANOMALY_RULE_SUCCESS,
  FETCH_SPECIFIC_ANOMALY_RULE_FAILURE,
  CLEAR_SPECIFIC_ANOMALY_RULE,
  SELECT_ANOMALY_RULE_PAGE
} from "../_constants";

const fetchSelectScopedAnomalyRuleRequest = (data) => {
  return { type: FETCH_SELECT_SCOPED_ANOMALY_RULE_REQUEST, payload: data };
};

const fetchSelectScopedAnomalyRuleSuccess = (data) => {
  return { type: FETCH_SELECT_SCOPED_ANOMALY_RULE_SUCCESS, payload: data };
};

const fetchSelectScopedAnomalyRuleFailure = (error) => {
  return { type: FETCH_SELECT_SCOPED_ANOMALY_RULE_FAILURE, payload: error };
};
export const clearSpecificAnomalyRule = () => {
  return { type: CLEAR_SPECIFIC_ANOMALY_RULE };
};

export const fetchSelectScopedAnomalyRule = (reqParams) => {
  return async (dispatch) => {
    dispatch(fetchSelectScopedAnomalyRuleRequest())
    return axios({
      method: "get",
      url: selectScopedAnomalyRuleAPI,
      params: {
        ...params,
        ...reqParams,
        userid: sessionStorage.getItem('userId')
      },

      headers: header,
    })
      .then((response) => {
        dispatch(fetchSelectScopedAnomalyRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchSelectScopedAnomalyRuleFailure(errorMsg));
      });
  };
};
const fetchSpecificAnomalyRuleSuccess = (data) => {
  return { type: FETCH_SPECIFIC_ANOMALY_RULE_SUCCESS, payload: data };
};

const fetchSpecificAnomalyRuleFailure = (error) => {
  return { type: FETCH_SPECIFIC_ANOMALY_RULE_FAILURE, payload: error };
};

export const fetchSpecificAnomalyRule = (id,machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: anomalyRuleAPI+id,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        with_signals: true,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchSpecificAnomalyRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchSpecificAnomalyRuleFailure(errorMsg));
      });
  };
};
export const selectAnomalyRulePageSelect = (data) => {
  return { type: SELECT_ANOMALY_RULE_PAGE, payload: data };
};
